import api from './index'

const AC_LAMBDA_URL = 'https://7nf2fxp2rksxslo4y5nlowihza0vidwh.lambda-url.us-east-2.on.aws/'

interface ACEmailPayload {
  email: string
  ip: string
  firstname: string
  lastname: string
  debt: number
  income: string
  faf: string
  seed: string
}

interface ACPhonePayload {
  email: string
  phone_number: string
  firstname: string
  lastname: string
  ip: string
  faf: string
  seed: string
}

interface ACAddressPayload {
  email: string
  state: string
  zip: string
  faf: string
  seed: string
}

interface ACArrayPayload {
  email: string
  arrayDebt: string
  creditScore: string
  collections: string
  delinquencies: string
  taxLiens: string
  studentLoans: string
  birthYear: string
  birthMonth: string
  birthDay: string
}

export async function sendEmailToAC(data: ACEmailPayload): Promise<void> {
  try {
    await api.post(AC_LAMBDA_URL, data, { timeout: 5000 })
  } catch (error) {
    console.error('AC email send error:', error)
  }
}

export async function sendPhoneToAC(data: ACPhonePayload): Promise<void> {
  try {
    await api.post(AC_LAMBDA_URL, data, { timeout: 5000 })
  } catch (error) {
    console.error('AC phone send error:', error)
  }
}

export async function sendAddressToAC(data: ACAddressPayload): Promise<void> {
  try {
    await api.post(AC_LAMBDA_URL, data, { timeout: 5000 })
  } catch (error) {
    console.error('AC address send error:', error)
  }
}

export async function sendArrayDataToAC(data: ACArrayPayload): Promise<void> {
  try {
    await api.post(AC_LAMBDA_URL, data, { timeout: 5000 })
  } catch (error) {
    console.error('AC array data send error:', error)
  }
}
